/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ContentZoneContext } from "cms/components/context";
import { useContext } from "react";
import { CardDisplay } from "./card-display";


const CardComponentDisplay = () => {
    const { component } = useContext(ContentZoneContext);
    const cards = component?.cards || [];

    console.log("Cards::", cards);

    return (
        <div className='simplicity-card-component-display'>
            <div className="simplicity-card-component-display-cards">
                {cards.map((card) => (
                    <CardDisplay key={card.guid} card={card} />
                ))}
            </div>
        </div>
    );
};

CardComponentDisplay.displayName = "CardComponentDisplay";
export { CardComponentDisplay };
